var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9393 7.04919L18.889 11.9989L18.888 12L18.889 12.001L13.9393 16.9508L13.02 16.0316L16.4072 12.6443H6.11096V11.3443H16.396L13.0201 7.96843L13.9393 7.04919Z",
    fill: "#1C2B33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 11.75,
    stroke: "#1C2B33",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowR);
export default __webpack_public_path__ + "static/media/arrow-r.97249ac0e00db74e7033eb8e9603ccd1.svg";
export { ForwardRef as ReactComponent };